
<div class="boxs-cont" style=" padding-top: 50px; direction: ltr ; padding-bottom: 50px; text-align: left">
    <div class="box-cont" style="background-color: #ffffff; direction: ltr ; padding: 20px; box-shadow: 0 3px 10px 0 rgba(0,0,0,0.08); width: 80%; margin: auto; font-size: 16px;">
<h4 [innerHtml]="title" style="font-weight: 100" ></h4>

    <div [innerHtml]="content" ></div>

    </div>
</div>

